import { FC } from "react";
import { SanityMainImage } from "../../graphql-types";
import Image from "./Image";
import * as styles from "./Figure.module.scss";

export interface FigureProps {
  value: SanityMainImage;
  fullQuality?: boolean;
}

const Figure: FC<FigureProps> = ({ value, fullQuality }) => {
  if (!value || !value.asset) {
    return null;
  }
  return (
    <figure className={styles.root}>
      <Image image={value} fullQuality={fullQuality} />
    </figure>
  );
};

export default Figure;
